import { AcceptedIcon } from "Assets/icons/v2";
import DocViewModal from "components/Common/DocViewModal";
import React, { useState } from "react";
import { useLazyGetFileUrlQuery } from "store/services/utility";
import { useGetPoliciesDataQuery } from "store/services/V2/profile";
import LoadingOverlay from "../LoadingOverlay";
import { useFormikContext } from "formik";


function Step1({ setFieldValue, values, data, isLoading }) {
    const { errors, touched, submitCount } = useFormikContext();

    const [showDocModal, setShowDocModal] = useState(false);
    const [selectedPolicy, setSelectedPolicy] = useState(null);
    const [getFileUrl, { isLoading: getFileLoading, isFetching: getFileFetching }] = useLazyGetFileUrlQuery();


    const handleOpenPolicy = async (policy) => {

        const result = await getFileUrl(policy?.policy);
        if (result?.error) return;

        const url = result?.data
        let policyData = {
            ...policy,
            url
        }

        if (url) {
            setSelectedPolicy(policyData);
            setShowDocModal(true);
        }

    };

    const handleAcceptPolicy = () => {
        if (!selectedPolicy) return;

        const updatedPolicies = [...(values.policies || [])];

        const existingIndex = updatedPolicies.findIndex(
            (p) => p.policy_id === selectedPolicy.id
        );

        if (existingIndex > -1) {
            updatedPolicies[existingIndex].is_accepted = true;
        } else {
            updatedPolicies.push({
                policy_id: selectedPolicy.id,
                is_accepted: true,
            });
        }

        setFieldValue("policies", updatedPolicies);
        setShowDocModal(false);
    };
    const showError =
        (touched.policies || submitCount > 0) && errors.policies;

    return (
        <div className="pt-3">
            {getFileLoading || isLoading && <LoadingOverlay />}

            {/* Header */}
            <div className="row">
                <div className="col-3 col-md-2"></div>
                <div className="col-6 col-md-5 step-policy-heading">
                    Click to Review & Accept
                </div>
                <div className="col-3 col-md-2 d-flex justify-content-center step-policy-heading">
                    Accepted
                </div>
            </div>

            {/* Policies */}
            {data.map((policy) => (
                <div key={policy.id} className="row align-items-center py-2">
                    <div className="col-3 col-md-2">
                        <span className="step-policy">{policy.name}</span>
                    </div>

                    <div className=" col-6 col-md-5">
                        <span
                            onClick={() => handleOpenPolicy(policy)}
                            className="step-policy-review text-purple"
                            style={{ cursor: "pointer" }}
                        >
                            View Policy
                        </span>
                    </div>

                    <div className="col-3 col-md-2 d-flex justify-content-center">
                        {values?.policies?.some(
                            (p) => p.policy_id === policy.id && p.is_accepted
                        ) && (
                                <span className="accepted-bg">
                                    <AcceptedIcon />
                                </span>
                            )}

                    </div>
                </div>
            ))}

            <div className="d-flex flex-column justify-content-start align-items-center mt-4">
                <p className='w-75 welcome-list'>
                    By selecting I AGREE you have accepted our terms and conditions and our privacy policy.
                </p>
            </div>

            <DocViewModal
                show={showDocModal}
                setShow={setShowDocModal}
                doc={selectedPolicy}
                onAccept={handleAcceptPolicy}
                values={values}
            />
            {showError && (
                <div className="error text-center mt-3">
                    {errors.policies}
                </div>
            )}
        </div>
    );
}

export default Step1;
